import React, { createRef, useContext, useEffect, useRef, useState } from "react";
import styles from './Home.module.css';
import sLogoStyles from '../footer/SLogoNew.module.css';
import { useNavigate, useOutletContext, useSearchParams } from "react-router-dom";
import Spinners from "./Spinners";
import HoverTextPara from "./HoverTextPara";
import ImageSwitcher from "./ImageSwitcher";
import { ReactComponent as Logo } from '../../imgs/designStrat/stratNew.svg';
import SLogo from "../footer/SLogo";
import SLogoNew from "../footer/SLogoNew";
import SLogoLoading from "../footer/SLogoLoading";
import { buildImgArray, aboutUsImgArray, visionImgArray, designStrategyImgArray, designStrategyImgArrayMobile } from "./ImageConfig";
import { serviceBlockData } from "./OurWorkConfig";
import { click } from "@testing-library/user-event/dist/click";
import AnimatedMap from "../animatedMap/AnimatedMap";
import { HeaderContext } from "../contextProviders/AlertContext";

var keys = {37: 1, 38: 1, 39: 1, 40: 1};

function preventDefault(e) {
    e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
}

// modern Chrome requires { passive: false } when adding event
var supportsPassive = false;
try {
window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
    get: function () { supportsPassive = true; } 
}));
} catch(e) {}

var wheelOpt = supportsPassive ? { passive: false } : false;
var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

// call this to Disable
function disableScroll() {
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);
}

// call this to Enable
function enableScroll() {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt); 
    window.removeEventListener('touchmove', preventDefault, wheelOpt);
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
}

export default function Home(){

    const {setMinimisedHeader} = useContext(HeaderContext);

    

    useEffect(() => {  
        enableScroll();
        return () => enableScroll();
    },[]);

    const stickCon1Ref = useRef();
    const stickCon2Ref = useRef();
    const stickCon3Ref = useRef();
    const stickBlock1Ref = useRef();
    const stickBlock2Ref = useRef();
    const stickBlock3Ref = useRef();

    const movingLogoCon = useRef();
    const movingLogoBlock = useRef();

    const [displayMovingLogo,setDisplayMovingLogo] = useState(true);

    const firstImageCon = useRef();
    const firstImage = useRef();
    const carousel = useRef();
    const carouselTimeoutRef = useRef();

    const [carouselImg,setCarouselImg] = useState(1);
    const [visibleCarouselImg,setVisibleCarouselImg] = useState(1);

    const [videoLoaded,setVideoLoaded] = useState(false);

    const [carouselTransitioning,setCarouselTransitioning] = useState(false);

    const carouselImgsOld = [
        './imgs/nov2025Imgs/designStrategy/web/kiosks_comp.jpg',
        './imgs/nov2025Imgs/weBuildBrands/HIQ.jpg',
        './imgs/nov2025Imgs/weBuildBrands/premioGuideline.jpg',
        './imgs/nov2025Imgs/weBuildBrands/Logos.jpg',
        './imgs/nov2025Imgs/weBuildBrands/table.jpg',
        './imgs/nov2025Imgs/weBuildBrands/Vulco.jpg'
    ];

    const carouselImgs = [
        // {
        //     type: 'video',
        //     src: require('./../../vids/S-Intro.mp4')
        // },
        {
            type: 'img',
            src: './imgs/nov2025Imgs/designStrategy/web/kiosks_comp.jpg',
        },
        {
            type: 'img',
            src: './imgs/nov2025Imgs/weBuildBrands/HIQ.jpg',
        },
        {
            type: 'img',
            src: './imgs/nov2025Imgs/weBuildBrands/premioGuideline.jpg',
        },
        {
            type: 'img',
            src: './imgs/nov2025Imgs/weBuildBrands/Logos.jpg',
        },
        {
            type: 'img',
            src: './imgs/nov2025Imgs/weBuildBrands/table.jpg',
        },
        {
            type: 'img',
            src: './imgs/nov2025Imgs/weBuildBrands/Vulco.jpg',
        },
        
    ];

    const extendedCarousel = [
        carouselImgs[carouselImgs.length - 1],
        ...carouselImgs,
        carouselImgs[0]
    ];

    useEffect(() => {
        setVisibleCarouselImg(() => {
            if(carouselImg >= carouselImgs.length){
                return carouselImgs.length;
            } else if (carouselImg <= 0) {
                return 1;
            } else {
                return carouselImg;
            }
        })
    },[carouselImg]);

    const processContainer = useRef();
    const processHeadingsContainer = useRef();
    const processBarConOuterRef = useRef();
    const processBarConRef = useRef();
    const processBarConRefMobile = useRef();
    const processBarRef = useRef();
    const processBarRefMobile = useRef();

    const process1Heading = useRef();
    const process2Heading = useRef();
    const process3Heading = useRef();
    const process4Heading = useRef();
    const process5Heading = useRef();

    const processSlider1 = useRef();
    const processSlider1Text = useRef();
    const processSlider2 = useRef();
    const processSlider2Text = useRef();
    const processSlider3 = useRef();
    const processSlider3Text = useRef();
    const processSlider4 = useRef();
    const processSlider4Text = useRef();
    const processSlider5 = useRef();
    const processSlider5Text = useRef();

    const weBuildH2Ref = useRef();
    const weBuildH5Ref = useRef();
    const weBuildH6Ref = useRef();

    const secondImageCon = useRef();
    const secondImage = useRef();

    const designStratConRef = useRef();
    const designStratTextRef = useRef();

    const designStratH2Ref = useRef();
    const designStratH5Ref = useRef();
    const designStratH6Ref = useRef();

    const aboutUsConRef = useRef();
    const aboutUsTextRef = useRef();

    const aboutUsH5Ref = useRef();
    const aboutUsH6Ref = useRef();
    const aboutUsH2Ref = useRef();

    const visionPurposeConRef = useRef();
    const visionPurposeTextRef = useRef();

    const visionPurposeH5Ref = useRef();
    const visionPurposeH6Ref = useRef();
    const visionPurposeH2Ref = useRef();

    const valuesRef = useRef();
    const valuesInteriorRef = useRef();
    
    const valuesH2Ref = useRef();
    const valuesH6Ref = useRef();

    const tiltingBlockOuterRef = useRef();
    const tiltingBlockRef = useRef();
    const glowBlockRef = useRef();

    const expandingGridRef = useRef();

    const servicesCarouselRef = useRef();
    const servicesCarouselInteriorConRef = useRef();
    const servicesCarouselInteriorRef = useRef();

    const navigate = useNavigate();

    const [searchParams,setSearchParams] = useSearchParams();
    
    const [serviceCurrentSlide,setServiceCurrentSlide] = useState(0);
    const [serviceCurrentSlideStyle,setServiceCurrentSlideStyle] = useState(true);
    const [serviceActiveSlide,setServiceActiveSlide] = useState(null);
    const [serviceProgress,setServiceProgress] = useState(0);
    const [autoActiveSlide,setAutoActiveSlide] = useState(false);
    const [delayOpen,setDelayOpen] = useState(null);
    const [activeWindowScroll,setActiveWindowScroll] = useState(0);

    const [serviceSlideShow,setServiceSlideShow] = useState(0);

    const awaitServiceSwitchRef = useRef();
    const awaitDoubleRef = useRef();
    const awaitDelayOpenRef = useRef();

    const resetServiceSwitchTimeout = () => {
        if(awaitServiceSwitchRef.current){
            clearTimeout(awaitServiceSwitchRef.current);
        }
    }
    
    const resetDoubleTimeout = () => {
        if(awaitDoubleRef.current){
            clearTimeout(awaitDoubleRef.current);
        }
    }

    const resetDelayOpenTimeout = () => {
        if(awaitDelayOpenRef.current){
            clearTimeout(awaitDelayOpenRef.current);
        }
    }

    useEffect(() => {
        resetServiceSwitchTimeout();
        resetDoubleTimeout();
        setServiceSlideShow(0);
        if(autoActiveSlide){
            setServiceCurrentSlideStyle(false);
            awaitServiceSwitchRef.current = setTimeout(() => {
                setServiceCurrentSlideStyle(true);
            }, 0);
            awaitDoubleRef.current = setTimeout(() => {
                setServiceActiveSlide(serviceCurrentSlide);
                disableScroll();
                setMinimisedHeader(true);
                setAutoActiveSlide(false);
            }, 500);
        } else {
            awaitServiceSwitchRef.current = setTimeout(() => {
                setServiceCurrentSlideStyle(true);
            }, 500);
            setServiceActiveSlide(null);
            enableScroll();
            setMinimisedHeader(false);
            setServiceSlideShow(0);
        }
        return resetServiceSwitchTimeout;
    },[serviceCurrentSlide]);

    // useEffect(() => {
    //     if(serviceActiveSlide === null){
    //         enableScroll();
    //     } else {
    //         disableScroll();
    //     }
    // },[serviceActiveSlide]);

    useEffect(() => {
        resetDelayOpenTimeout();
        if(delayOpen !== null){
            awaitDelayOpenRef.current = setTimeout(() => {
                expandServiceBlock('',delayOpen)
            }, 500);
        } else {
            setServiceActiveSlide(null);
            enableScroll();
            setMinimisedHeader(false);
            setServiceSlideShow(0);
        }
        return resetServiceSwitchTimeout;
    },[delayOpen]);

    const serviceBlocks = useRef(serviceBlockData.map(() => createRef()));

    const [logoStatePt1,setLogoStatePt1] = useState(0);
    const [logoStatePt2,setLogoStatePt2] = useState(0);

    const {mobileVersion} = useOutletContext();

    const [headingStyles,setHeadingStyles] = useState({
        top: (window.innerHeight/2) - (7.875*16),
        opacity: 1
    });


    // Track section visibility for slideshow reset
    const [visionSectionInView,setVisionSectionInView] = useState(false);

    const titleHeadingScrollFunction = () => {
        const headingDefaultTop = (window.innerHeight/2) - (7.875*16);
        const newHeadingTop = headingDefaultTop - (window.scrollY/1.5);
        let opacity = newHeadingTop/headingDefaultTop;
        if(newHeadingTop < 0){
            opacity = 0;
        };
        setHeadingStyles({
            top: newHeadingTop,
            opacity: opacity
        });
    }

    const servicesFunctionOnly = (parentElementId,setterFunction) => {
        const element = document.getElementById(parentElementId).getBoundingClientRect();
    
        const viewportHeight = window.innerHeight;

        let topPosition;
        if (element.top >= viewportHeight){
            // start position
            topPosition = 0;
        } else if (element.bottom <= 0) {
            // end position
            topPosition = -0.5*viewportHeight;
        } else {
            topPosition = viewportHeight*((element.top/viewportHeight)-1)/4;
        }

        let opacity;
        if(element.top >= viewportHeight){
            opacity = 0;
        } else if (element.bottom <= 0) {
            opacity = 0;
        } else if (element.top <= viewportHeight*0.5 && element.bottom >= viewportHeight*(0.15)){
            opacity = 1;
        } else if (element.top > viewportHeight*0.5 && element.top < viewportHeight){
            opacity = 0;
        } else if (element.top < viewportHeight*(-0.25) && element.bottom > 0){
            opacity = (4/3)*(1+(element.top/viewportHeight));
        }
        setterFunction({
            top: topPosition,
            opacity
        });
    }

    const checkSectionInView = (sectionId) => {
        const element = document.getElementById(sectionId);
        if(!element) return false;
        const rect = element.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        // Section is in view if it's within the viewport (top is above bottom of viewport and bottom is below top of viewport)
        return rect.top < viewportHeight && rect.bottom > 0;
    };

    const onScrollFunction = () => {
        titleHeadingScrollFunction();
        processBarFunc();
        processBarFunc2();
        processImgFunc(processSlider1,processSlider1Text);
        processImgFunc(processSlider2,processSlider2Text);
        processImgFunc(processSlider3,processSlider3Text);
        processImgFunc(processSlider4,processSlider4Text);
        processImgFunc(processSlider5,processSlider5Text);
        movingLogoFunc();
        firstImageFunc();
        secondImageFunc();
        servicesCarouselFunc();
        valuesMovingFunc();
        stickyTextFunc(designStratConRef,designStratTextRef);
        stickyTextFunc(aboutUsConRef,aboutUsTextRef);
        stickyTextFunc(visionPurposeConRef,visionPurposeTextRef);
        // textOpacityFunc(weBuildH2Ref);
        // textOpacityFunc(weBuildH5Ref);
        // textOpacityFunc(weBuildH6Ref);
        textOpacityFunc(designStratH2Ref);
        textOpacityFunc(designStratH5Ref);
        textOpacityFunc(designStratH6Ref);
        textOpacityFunc(aboutUsH2Ref);
        textOpacityFunc(aboutUsH5Ref);
        textOpacityFunc(aboutUsH6Ref);
        textOpacityFunc(visionPurposeH2Ref);
        textOpacityFunc(visionPurposeH5Ref);
        textOpacityFunc(visionPurposeH6Ref);
        textOpacityFunc(valuesH2Ref);
        textOpacityFunc(valuesH6Ref);
        
        // Check section visibility for slideshow reset
        setVisionSectionInView(checkSectionInView('visionSection'));
    }

    const mouseMoveFunction = (e) => {
        // console.log(e)
        // tiltingFunction(e,tiltingBlockOuterRef,tiltingBlockRef);
        // hoverGlowFunction(e,glowBlockRef);
    }

    const tiltingFunction = (e,outerRef,blockRef) => {
        if(blockRef){
            const blockTop = outerRef.current.getBoundingClientRect().top;
            const blockBottom = outerRef.current.getBoundingClientRect().bottom;
            const blockLeft = outerRef.current.getBoundingClientRect().left;
            const blockRight = outerRef.current.getBoundingClientRect().right;
            const blockMiddleX = (blockRight+blockLeft)/2;
            const blockMiddleY = (blockTop+blockBottom)/2;
            const blockWidth = blockRight-blockLeft;
            const blockHeight = blockBottom-blockTop;
            const mousePosX = e.clientX;
            const mousePosY = e.clientY;
            const buffer = 0;
            let xTilt;
            let yTilt;
            if(e.clientX >= (blockLeft - buffer) && e.clientX <= (blockRight + buffer) && e.clientY >= (blockTop - buffer) && e.clientY <= (blockBottom + buffer)){
                xTilt = (mousePosX-blockMiddleX)/(blockWidth/2);
                yTilt = (mousePosY-blockMiddleY)/(blockHeight/2);
                // console.log('inside');
                // console.log('blockTop',blockTop,'blockBottom',blockBottom,'blockLeft',blockLeft,'blockRight',blockRight);
                blockRef.current.style.transform = `perspective(1000px) rotateX(${-yTilt*5}deg) rotateY(${xTilt*5}deg)`;
            } else {
                // console.log('outside');
                blockRef.current.style.transform = `perspective(1000px) rotateX(0deg) rotateY(0deg)`;
            }
        }
    }

    const hoverGlowFunction = (e,blockRef) => {
        if(blockRef){
            const blockTop = blockRef.current.getBoundingClientRect().top;
            const blockBottom = blockRef.current.getBoundingClientRect().bottom;
            const blockLeft = blockRef.current.getBoundingClientRect().left;
            const blockRight = blockRef.current.getBoundingClientRect().right;
            const mousePosX = e.clientX;
            const mousePosY = e.clientY;
            let xTilt;
            let yTilt;
            if(e.clientX >= blockLeft && e.clientX <= blockRight && e.clientY >= blockTop && e.clientY <= blockBottom){
                blockRef.current.style = `--x: ${mousePosX-blockLeft}px; --y: ${mousePosY-blockTop}px`;
            } else {
                blockRef.current.style.transform = `perspective(1000px) rotateX(0deg) rotateY(0deg)`;
            }
        }
    }

    const stickyConFunc = (conRef,blockRef,stateSetter) => {
        const viewportHeight = window.innerHeight;
        const blockTop = conRef.current.getBoundingClientRect().top;
        const blockBottom = conRef.current.getBoundingClientRect().bottom;
        if(blockTop <= 0){
            blockRef.current.style.position = `fixed`;
            blockRef.current.style.top = `${0}px`;
            if(blockBottom <= viewportHeight && blockBottom > 0){
                stateSetter((((viewportHeight)-blockBottom)/(viewportHeight)))
            }
        } else {
            blockRef.current.style.position = `absolute`;
            blockRef.current.style.top = `0px`;
        }
    }

    const movingLogoFunc = () => {
        const viewportHeight = window.innerHeight;
        const blockHeight = movingLogoCon.current.getBoundingClientRect().bottom - movingLogoCon.current.getBoundingClientRect().top;
        const halfHeight = blockHeight/2;
        const blockTop = movingLogoCon.current.getBoundingClientRect().top;
        const blockBottom = movingLogoCon.current.getBoundingClientRect().bottom;
        const blockMiddle = (movingLogoCon.current.getBoundingClientRect().bottom + movingLogoCon.current.getBoundingClientRect().top)/2;
        const twoThirdsHeight = 2*blockHeight/3;
        const blockTwoThirds = (movingLogoCon.current.getBoundingClientRect().bottom + movingLogoCon.current.getBoundingClientRect().top)/2;

        if (blockTop >= 0) {
            setLogoStatePt1(0);
            setLogoStatePt2(0);
            movingLogoBlock.current.style.position = `absolute`;
            movingLogoBlock.current.style.top = `0`;
            movingLogoBlock.current.style.bottom = `unset`;
            movingLogoBlock.current.style.display = `block`;
            if(blockTop > viewportHeight){
                setDisplayMovingLogo(false);
            } else {
                setDisplayMovingLogo(true);
            }
        } else if (blockTop <= 0 && blockMiddle >= viewportHeight/2){
            setLogoStatePt1((2*(1-((halfHeight+blockTop)/(halfHeight)))));
            setLogoStatePt2(0);
            movingLogoBlock.current.style.position = `fixed`;
            movingLogoBlock.current.style.top = `0`;
            movingLogoBlock.current.style.display = `block`;
            setDisplayMovingLogo(true);
        } else if (blockMiddle < viewportHeight && blockBottom >= viewportHeight) {
            setLogoStatePt1(1);
            console.log((1.5-(((halfHeight)+blockMiddle)/(halfHeight))));
            setLogoStatePt2(2*(1.5-(((halfHeight)+blockMiddle)/(halfHeight))));
            movingLogoBlock.current.style.position = `fixed`;
            movingLogoBlock.current.style.top = `0`;
            movingLogoBlock.current.style.display = `block`;
            setDisplayMovingLogo(true);
        } else if (blockBottom < viewportHeight && blockBottom > 0){
            setLogoStatePt1(1);
            setLogoStatePt2(1);
            movingLogoBlock.current.style.position = `absolute`;
            movingLogoBlock.current.style.top = `unset`;
            movingLogoBlock.current.style.bottom = `0`;
            movingLogoBlock.current.style.display = `block`;
            setDisplayMovingLogo(true);
        } else if(blockBottom <= 0){
            // movingLogoBlock.current.style.top = `unset`;
            // movingLogoBlock.current.style.bottom = `0`;
            movingLogoBlock.current.style.display = `none`;
            setDisplayMovingLogo(false);
        }
    }

    const firstImageFunc = () => {
        const viewportHeight = window.innerHeight;
        const blockTop = firstImageCon.current.getBoundingClientRect().top;
        const blockBottom = firstImageCon.current.getBoundingClientRect().bottom;

        if (blockTop > viewportHeight) {
            firstImage.current.style.opacity = `0`;
            firstImage.current.style.top = '-25lvh'
        } else if (blockTop <= viewportHeight && blockBottom >= 0){
            firstImage.current.style.opacity = `1`;
            firstImage.current.style.top = `-${12.5*(blockBottom/(1.75*viewportHeight))}vh`
        } else if (blockBottom < 0){
            firstImage.current.style.opacity = `0`;
            firstImage.current.style.top = '0'
        }
    }

    const stickyTextFunc = (conRef,textRef) => {
        const viewportHeight = window.innerHeight;
        const blockTop = conRef.current.getBoundingClientRect().top;
        const blockBottom = conRef.current.getBoundingClientRect().bottom;
        const blockWidth = conRef.current.getBoundingClientRect().right - conRef.current.getBoundingClientRect().left;
        const textTop = textRef.current.getBoundingClientRect().top;
        const textBottom = textRef.current.getBoundingClientRect().bottom;
        const textHeight = textBottom-textTop;
        const textWidth = (blockWidth/2) - (4*16);
        const padding = (viewportHeight-textHeight)/2;
        if(window.innerWidth > 900){
            if (blockTop >= padding) {
                textRef.current.style.position = `absolute`;
                textRef.current.style.top = `0`;
                textRef.current.style.bottom = `unset`;
                textRef.current.style.display = `block`;
                textRef.current.style.width = textWidth+'px';
            } else if (blockTop <= padding && blockBottom > textHeight+(padding)){
                textRef.current.style.position = `fixed`;
                textRef.current.style.top = padding+'px';
                textRef.current.style.display = `block`;
                textRef.current.style.width = textWidth+'px';
            } else if (blockBottom <= textHeight+(padding)){
                textRef.current.style.position = `absolute`;
                textRef.current.style.top = `unset`;
                textRef.current.style.bottom = `0`;
                textRef.current.style.display = `block`;
                textRef.current.style.width = textWidth+'px';
            } else if(blockBottom <= 0){
                textRef.current.style.display = `none`;
            }
        }
    }

    const processBarFunc = () => {
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;
        const blockCon = processContainer.current.getBoundingClientRect();
        const blockConHeight = blockCon.bottom-blockCon.top;
        const conOuterWidth = processBarConOuterRef.current.getBoundingClientRect().right - processBarConOuterRef.current.getBoundingClientRect().left;
        const margin = (conOuterWidth - (0.375*16))/2;
        processBarConOuterRef.current.style.margin = `0 0 0 ${margin}px`

        if (blockCon.top > (5*16)) {

            // processBarRef.current.style.height = '0';
            processBarRefMobile.current.style.height = '0';
            processBarConRef.current.style.position = 'absolute';
            processBarConRef.current.style.top = '0';
            processBarConRefMobile.current.style.position = 'absolute';
            processBarConRefMobile.current.style.top = '0';
            processHeadingsContainer.current.style.position = 'absolute';
            processHeadingsContainer.current.style.top = '0';
            process1Heading.current.style.opacity = '0.25';
            process2Heading.current.style.opacity = '0.25';
            process3Heading.current.style.opacity = '0.25';
            process4Heading.current.style.opacity = '0.25';
            process5Heading.current.style.opacity = '0.25';

            if(viewportWidth > viewportHeight){
                processSlider1.current.style.opacity = '0.25';
                processSlider2.current.style.opacity = '0.25';
                processSlider3.current.style.opacity = '0.25';
                processSlider4.current.style.opacity = '0.25';
                processSlider5.current.style.opacity = '0.25';
            }
        } else if (blockCon.top <= (5*16) && blockCon.bottom > viewportHeight - 16){

            // processBarRef.current.style.height = `${(viewportHeight/2) - blockTop}px`;
            const percentage = (1-((blockCon.bottom - (viewportHeight - 16))/(blockConHeight - (viewportHeight - (6*16)))))*100;
            // bottom - upper bound / block height - distance between upper and lower bound
            console.log(percentage);
            processBarRef.current.style.height = `${percentage}%`;
            processBarRefMobile.current.style.height = `${percentage}%`;
            processBarConRef.current.style.position = 'fixed';
            processBarConRef.current.style.top = '5rem';
            processBarConRefMobile.current.style.position = 'fixed';
            processBarConRefMobile.current.style.top = '5rem';
            processHeadingsContainer.current.style.position = 'fixed';
            processHeadingsContainer.current.style.top = '5rem';
            if (percentage >= 0 && percentage < 20){
                process1Heading.current.style.opacity = '1';
                process2Heading.current.style.opacity = '0.25';
                process3Heading.current.style.opacity = '0.25';
                process4Heading.current.style.opacity = '0.25';
                process5Heading.current.style.opacity = '0.25';

                if(viewportWidth > viewportHeight){
                    processSlider1.current.style.opacity = '1';
                    processSlider2.current.style.opacity = '0.25';
                    processSlider3.current.style.opacity = '0.25';
                    processSlider4.current.style.opacity = '0.25';
                    processSlider5.current.style.opacity = '0.25';
                }
            } else if (percentage >= 20 && percentage < 40){
                process1Heading.current.style.opacity = '0.25';
                process2Heading.current.style.opacity = '1';
                process3Heading.current.style.opacity = '0.25';
                process4Heading.current.style.opacity = '0.25';
                process5Heading.current.style.opacity = '0.25';

                if(viewportWidth > viewportHeight){
                    processSlider1.current.style.opacity = '0.25';
                    processSlider2.current.style.opacity = '1';
                    processSlider3.current.style.opacity = '0.25';
                    processSlider4.current.style.opacity = '0.25';
                    processSlider5.current.style.opacity = '0.25';
                }
            } else if (percentage >= 40 && percentage < 60){
                process1Heading.current.style.opacity = '0.25';
                process2Heading.current.style.opacity = '0.25';
                process3Heading.current.style.opacity = '1';
                process4Heading.current.style.opacity = '0.25';
                process5Heading.current.style.opacity = '0.25';

                if(viewportWidth > viewportHeight){
                    processSlider1.current.style.opacity = '0.25';
                    processSlider2.current.style.opacity = '0.25';
                    processSlider3.current.style.opacity = '1';
                    processSlider4.current.style.opacity = '0.25';
                    processSlider5.current.style.opacity = '0.25';
                }
            } else if (percentage >= 60 && percentage < 80){
                process1Heading.current.style.opacity = '0.25';
                process2Heading.current.style.opacity = '0.25';
                process3Heading.current.style.opacity = '0.25';
                process4Heading.current.style.opacity = '1';
                process5Heading.current.style.opacity = '0.25';

                if(viewportWidth > viewportHeight){
                    processSlider1.current.style.opacity = '0.25';
                    processSlider2.current.style.opacity = '0.25';
                    processSlider3.current.style.opacity = '0.25';
                    processSlider4.current.style.opacity = '1';
                    processSlider5.current.style.opacity = '0.25';
                }
            } else if (percentage >= 80 && percentage < 100){
                process1Heading.current.style.opacity = '0.25';
                process2Heading.current.style.opacity = '0.25';
                process3Heading.current.style.opacity = '0.25';
                process4Heading.current.style.opacity = '0.25';
                process5Heading.current.style.opacity = '1';

                if(viewportWidth > viewportHeight){
                    processSlider1.current.style.opacity = '0.25';
                    processSlider2.current.style.opacity = '0.25';
                    processSlider3.current.style.opacity = '0.25';
                    processSlider4.current.style.opacity = '0.25';
                    processSlider5.current.style.opacity = '1';
                }
            }
            

        } else if (blockCon.bottom <= viewportHeight - 16){

            processBarRef.current.style.height = '100%';
            processBarRefMobile.current.style.height = '100%';
            processBarConRef.current.style.position = 'absolute';
            processBarConRef.current.style.top = 'unset';
            processBarConRef.current.style.bottom = '0';
            processBarConRefMobile.current.style.position = 'absolute';
            processBarConRefMobile.current.style.top = 'unset';
            processBarConRefMobile.current.style.bottom = '1rem';
            processHeadingsContainer.current.style.position = 'absolute';
            processHeadingsContainer.current.style.top = 'unset';
            processHeadingsContainer.current.style.bottom = '1rem';
        }
    }

    const processImgFunc = (sliderRef,textRef) => {
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;

        const blockTop = sliderRef.current.getBoundingClientRect().top;
        const blockBottom = sliderRef.current.getBoundingClientRect().bottom;
        const blockMiddle =( blockBottom+blockTop)/2;
        const blockLeft = sliderRef.current.getBoundingClientRect().left;
        const blockRight = sliderRef.current.getBoundingClientRect().right;
        const blockHeight = blockBottom-blockTop;
        const blockWidth = blockRight-blockLeft;

        if(viewportHeight > viewportWidth){
            if (blockTop > viewportHeight/3) {
                sliderRef.current.style.left = '0';
                textRef.current.style.opacity = '0';
            } else if (blockTop <= viewportHeight/3){
                sliderRef.current.style.left = `-${(blockWidth/2)+(2*16)}px`;
                textRef.current.style.opacity = '1';
            }
        } else {
            if (blockMiddle > viewportHeight/2) {
                sliderRef.current.style.left = '0';
                textRef.current.style.opacity = '0';
            } else if (blockMiddle <= viewportHeight/2){
                sliderRef.current.style.left = `-${(blockWidth/2)+(2*16)}px`;
                textRef.current.style.opacity = '1';
            }
        }
    }

    const processBarFunc2 = () => {
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;
        const blockCon = processContainer.current.getBoundingClientRect();
        const process1 = processSlider1.current.getBoundingClientRect();
        const process1Middle = (process1.top+process1.bottom)/2;
        const process2 = processSlider2.current.getBoundingClientRect();
        const process2Middle = (process2.top+process2.bottom)/2;
        const process3 = processSlider3.current.getBoundingClientRect();
        const process3Middle = (process3.top+process3.bottom)/2;
        const process4 = processSlider4.current.getBoundingClientRect();
        const process4Middle = (process4.top+process4.bottom)/2;
        const process5 = processSlider5.current.getBoundingClientRect();
        const process5Middle = (process5.top+process5.bottom)/2;

        if(viewportHeight < viewportWidth){
            if (process1Middle >= viewportHeight/2) {
                // processBarRef.current.style.height = `0%`;

                // process1Heading.current.style.opacity = '0.5';
                // process2Heading.current.style.opacity = '0.5';
                // process3Heading.current.style.opacity = '0.5';
                // process4Heading.current.style.opacity = '0.5';
                // process5Heading.current.style.opacity = '0.5';

            }
            if (process1Middle < viewportHeight/2) {
                // processBarRef.current.style.height = `10%`;

                // process1Heading.current.style.opacity = '1';
                // process2Heading.current.style.opacity = '0.5';
                // process3Heading.current.style.opacity = '0.5';
                // process4Heading.current.style.opacity = '0.5';
                // process5Heading.current.style.opacity = '0.5';
            }
            if (process2Middle < viewportHeight/2) {
                // processBarRef.current.style.height = `30%`;

                // process1Heading.current.style.opacity = '0.5';
                // process2Heading.current.style.opacity = '1';
                // process3Heading.current.style.opacity = '0.5';
                // process4Heading.current.style.opacity = '0.5';
                // process5Heading.current.style.opacity = '0.5';
            }
            if (process3Middle < viewportHeight/2) {
                // processBarRef.current.style.height = `50%`;

                // process1Heading.current.style.opacity = '0.5';
                // process2Heading.current.style.opacity = '0.5';
                // process3Heading.current.style.opacity = '1';
                // process4Heading.current.style.opacity = '0.5';
                // process5Heading.current.style.opacity = '0.5';
            }
            if (process4Middle < viewportHeight/2) {
                // processBarRef.current.style.height = `70%`;

                // process1Heading.current.style.opacity = '0.5';
                // process2Heading.current.style.opacity = '0.5';
                // process3Heading.current.style.opacity = '0.5';
                // process4Heading.current.style.opacity = '1';
                // process5Heading.current.style.opacity = '0.5';
            }
            if (process5Middle < viewportHeight/2) {
                // processBarRef.current.style.height = `90%`;

                // process1Heading.current.style.opacity = '0.5';
                // process2Heading.current.style.opacity = '0.5';
                // process3Heading.current.style.opacity = '0.5';
                // process4Heading.current.style.opacity = '0.5';
                // process5Heading.current.style.opacity = '1';
            }
            if (blockCon.bottom < viewportHeight - 16){
                // processBarRef.current.style.height = `100%`;

                // process1Heading.current.style.opacity = '0.5';
                // process2Heading.current.style.opacity = '0.5';
                // process3Heading.current.style.opacity = '0.5';
                // process4Heading.current.style.opacity = '0.5';
                // process5Heading.current.style.opacity = '1';
            }
        } else {
            // if (process1.top >= viewportHeight/3) {
            //     processBarRefMobile.current.style.height = `0%`;
            // }
            // if (process1.top < viewportHeight/3) {
            //     processBarRefMobile.current.style.height = `10%`;
            // }
            // if (process2.top < viewportHeight/3) {
            //     processBarRefMobile.current.style.height = `30%`;
            // }
            // if (process3.top < viewportHeight/3) {
            //     processBarRefMobile.current.style.height = `50%`;
            // }
            // if (process4.top < viewportHeight/3) {
            //     processBarRefMobile.current.style.height = `70%`;
            // }
            // if (process5.top < viewportHeight/3) {
            //     processBarRefMobile.current.style.height = `90%`;
            // }
            // if (blockCon.bottom < viewportHeight - 16){
            //     processBarRefMobile.current.style.height = `100%`;
            // }
        }
        // processImgFunc(processSlider1,processSlider1Text);
        // processImgFunc(processSlider2,processSlider2Text);
        // processImgFunc(processSlider3,processSlider3Text);
        // processImgFunc(processSlider4,processSlider4Text);
        // processImgFunc(processSlider5,processSlider5Text);
    }

    const secondImageFunc = () => {
        const viewportHeight = window.innerHeight;
        const blockTop = secondImageCon.current.getBoundingClientRect().top;
        const blockBottom = secondImageCon.current.getBoundingClientRect().bottom;

        if (blockTop > viewportHeight) {
            secondImage.current.style.opacity = `0`;
            secondImage.current.style.top = '-25lvh'
        } else if (blockTop <= viewportHeight && blockBottom >= 0){
            secondImage.current.style.opacity = `1`;
            secondImage.current.style.top = `-${25*(blockBottom/(1.75*viewportHeight))}vh`
        } else if (blockBottom < 0){
            secondImage.current.style.opacity = `0`;
            secondImage.current.style.top = '0'
        }
    }

    const nextCarouselImg = () => {
        if(!carouselTransitioning){
            setCarouselImg((prev) => {
                // if(prev === carouselImgs.length - 1){
                //     return 0;
                // } else {
                //     return prev + 1;
                // }
                return prev + 1;
            });
            setCarouselTransitioning(true);
        }
    }

    const prevCarouselImg = () => {
        if(!carouselTransitioning){
            setCarouselImg((prev) => {
                return prev - 1;
            });
            setCarouselTransitioning(true);
        }
    }

    const nextCarouselImgAuto = () => {
        setCarouselImg((prev) => prev + 1);
        setCarouselTransitioning(true);
    }

    const handleClickSlideNo = (no) => {
        setCarouselImg(no);
        setCarouselTransitioning(true);
    }

    const handleCarouselTransitionEnd = () => {
        if (carouselImg >= extendedCarousel.length - 1) {
        // jumped past last clone → reset to real first
            setCarouselTransitioning(false);
            setCarouselImg(1);
        } else if (carouselImg <= 0) {
        // jumped before first clone → reset to real last
            setCarouselTransitioning(false);
            setCarouselImg(carouselImgs.length);
        }
        setCarouselTransitioning(false);
    }

    const resetCarouselTimeout = () => {
        if(carouselTimeoutRef.current){
            clearTimeout(carouselTimeoutRef.current);
        }
    }

    useEffect(() => {
        resetCarouselTimeout();
        carouselTimeoutRef.current = setTimeout(() => {
            if(carouselImg !== 0){
                nextCarouselImgAuto();
            }
        }, 6000);
        return resetCarouselTimeout;
    },[visibleCarouselImg]);

    const textOpacityFunc = (ref) => {
        const textBlock = ref.current.getBoundingClientRect();
        if(textBlock.top < 5*(window.innerHeight/6)){
            ref.current.style.opacity = '1';
        } else {
            ref.current.style.opacity = '0';
        }
    }

    const servicesCarouselFunc = (override) => {
        const noOfBlocks = serviceBlockData.length;
        const servCarBlock = servicesCarouselRef.current.getBoundingClientRect();

        if(servCarBlock.top <= window.innerHeight/3 && servCarBlock.bottom >= window.innerHeight){
            if(servCarBlock.top < window.innerHeight/3 && servCarBlock.top > 1){
            servicesCarouselInteriorConRef.current.style.position = 'absolute';
            servicesCarouselInteriorConRef.current.style.top = `0`;
            servicesCarouselInteriorConRef.current.style.bottom = `unset`;
            servicesCarouselInteriorConRef.current.style.opacity = `1`;
            servicesCarouselInteriorConRef.current.style.width = `${servCarBlock.right - servCarBlock.left}px`;
            } else {
                servicesCarouselInteriorConRef.current.style.width = `${servCarBlock.right - servCarBlock.left}px`;
                servicesCarouselInteriorConRef.current.style.position = 'fixed';
                servicesCarouselInteriorConRef.current.style.top = `0`;
                servicesCarouselInteriorConRef.current.style.bottom = `unset`;
                servicesCarouselInteriorConRef.current.style.opacity = `1`;
                if(servCarBlock.top <= 1){
                    const blockHeight = servCarBlock.bottom-servCarBlock.top-window.innerHeight; //v important
                    const sectionHeight = blockHeight/(noOfBlocks);
                    const sectionNo = Math.floor(Math.abs(servCarBlock.top)/sectionHeight);
                    servicesCarouselInteriorRef.current.style.transform = `translate(0,-${sectionNo*(7*16)}px)`; 
                    if(activeWindowScroll === 0 || override){
                        console.log('sectionNo', sectionNo);
                        setServiceCurrentSlide(sectionNo);
                    }
                }
                setServiceProgress(1-(Math.abs((servCarBlock.bottom-servCarBlock.top)+servCarBlock.top-window.innerHeight)/(servCarBlock.bottom-servCarBlock.top-window.innerHeight)));
            }
       } else if (servCarBlock.top > window.innerHeight/3){
            servicesCarouselInteriorConRef.current.style.position = 'absolute';
            servicesCarouselInteriorConRef.current.style.top = `100vh`;
            servicesCarouselInteriorConRef.current.style.bottom = `unset`;
            servicesCarouselInteriorConRef.current.style.opacity = `0`;
        } else if (servCarBlock.bottom < window.innerHeight ){
            servicesCarouselInteriorConRef.current.style.position = 'absolute';
            servicesCarouselInteriorConRef.current.style.bottom = `0`;
            servicesCarouselInteriorConRef.current.style.top = `unset`;
            if(servCarBlock.bottom < window.innerHeight/2){
                servicesCarouselInteriorConRef.current.style.opacity = `0`;
            } else {
                servicesCarouselInteriorConRef.current.style.opacity = `1`;
            }
        }            
    }
    
    const navigateForwardSlideShow = (maxSlides,button) => {
        setServiceSlideShow((prev) => {
            if(prev < maxSlides){
                return Number(prev)+1;
            } else {
                closeSlideShowBasic();
                if(button && serviceCurrentSlide < serviceBlockData.length -1){
                    setDelayOpen(serviceCurrentSlide+1)
                }
                return 0;
            }
        });
    }
    
    const navigateBackwardSlideShow = (button) => {
        setServiceSlideShow((prev) => {
            if(prev === 0){
                closeSlideShowBasic();
                if(button && serviceCurrentSlide >= 0){
                    setDelayOpen(serviceCurrentSlide-1)
                }
                return 0;
            } else {
                return Number(prev)-1;
            }
        });
    }
    
    const closeSlideShow = () => {
        closeSlideShowBasic();
        setServiceSlideShow(0);
    }
    const closeSlideShowBasic = () => {
        setServiceActiveSlide(null);
        enableScroll();
        setMinimisedHeader(false);
        setSearchParams("");
    }

    const windowScroll = (resultHeight) => {
        setActiveWindowScroll(resultHeight);
        window.scrollTo(0,resultHeight);
    }
    
    const expandServiceBlock = (clicked,index) => {
        const noOfBlocks = serviceBlockData.length;
        const bodyBlock = document.body.getBoundingClientRect();
        const servCarBlock = servicesCarouselRef.current.getBoundingClientRect();
        const sectionHeight = (servCarBlock.bottom - servCarBlock.top - window.innerHeight)/noOfBlocks;
        windowScroll((servCarBlock.top - bodyBlock.top)+(sectionHeight/2)+(((sectionHeight)*index)));
        if(serviceCurrentSlide === index){
            setServiceActiveSlide(index);
            disableScroll();
            setMinimisedHeader(true);
        } else {
            setServiceActiveSlide(null);
            enableScroll();
            setMinimisedHeader(false);
            setAutoActiveSlide(true);
        }
    }    

    useEffect(() => {
        // Initial check for section visibility
        onScrollFunction();
        
        window.addEventListener('mousemove', mouseMoveFunction);
        window.addEventListener('scroll', onScrollFunction);
        return () => {
            window.removeEventListener('scroll', onScrollFunction);
            window.removeEventListener('mousemove', mouseMoveFunction);
        }
    },[]);

    const [spin1,setSpin1] = useState(0);
    const [spin2,setSpin2] = useState(0);
    const [spin3,setSpin3] = useState(0);
    const [spin4,setSpin4] = useState(0);

    const valuesMovingFunc = () => {
        const viewportHeight = window.innerHeight;
        const blockHeight = valuesRef.current.getBoundingClientRect().bottom - valuesRef.current.getBoundingClientRect().top;
        const blockTop = valuesRef.current.getBoundingClientRect().top;
        const blockBottom = valuesRef.current.getBoundingClientRect().bottom;
        if (blockTop >= 0) {
            valuesInteriorRef.current.style.position = `absolute`;
            valuesInteriorRef.current.style.top = `0`;
            valuesInteriorRef.current.style.bottom = `unset`;
            valuesInteriorRef.current.style.display = `block`;
        } else if (blockTop <= 0 && blockBottom >= viewportHeight){
            valuesInteriorRef.current.style.position = `fixed`;
            valuesInteriorRef.current.style.top = `0`;
            valuesInteriorRef.current.style.display = `block`;
        } else if (blockBottom <= viewportHeight){
            valuesInteriorRef.current.style.position = `absolute`;
            valuesInteriorRef.current.style.top = `unset`;
            valuesInteriorRef.current.style.bottom = `0`;
            // valuesInteriorRef.current.style.display = `none`;
        }

        //spin

        const viewportPercentage = viewportHeight*0.55
        const movementWindow = viewportHeight*3;
        const rotation = 1080;

        if(blockTop > -viewportPercentage*0){
            setSpin1(-rotation*((blockTop+(viewportPercentage*0))/(movementWindow)));
        } else if (blockTop <= -viewportPercentage*0){
            setSpin1(0);
        }

        if(blockTop > -viewportPercentage*1){
            setSpin2(-rotation*((blockTop+(viewportPercentage*1))/(movementWindow)));
        } else if (blockTop <= -viewportPercentage*1){
            setSpin2(0);
        }

        if(blockTop > -viewportPercentage*2){
            setSpin3(-rotation*((blockTop+(viewportPercentage*2))/(movementWindow)));
        } else if (blockTop <= -viewportPercentage*2){
            setSpin3(0);
        }
        if(blockTop > -viewportPercentage*3){
            setSpin4(-rotation*((blockTop+(viewportPercentage*3))/(movementWindow)));
        } else if (blockTop <= -viewportPercentage*3){
            setSpin4(0);
        }

    }

    class SpinnerObj {
        constructor(topText1,topText2,bottomText1,bottomText2,imgNo){
            this.topText1 = topText1;
            this.topText2 = topText2;
            this.bottomText1 = bottomText1;
            this.bottomText2 = bottomText2;
            this.imgNo = imgNo;
        }
    };

    const spinnersArray = [
        new SpinnerObj('Think wide','& far','Innovate &','create change',"1"),
        new SpinnerObj('Always learn','& Improve','Aim for better','',"2"),
        new SpinnerObj('Listen','& respond','Show honesty','& respect',"3"),
        new SpinnerObj('Love','the detail','Create WOW','',"4")
    ];

    class ServicesItems {
        constructor(id,headingText,bodyText){
            this.id = id;
            this.headingText = headingText;
            this.bodyText = bodyText;
        }
    }

    const servicesArray = [
        new ServicesItems('service1','Brand Identity','We help to create brands that deliver the essence of your product or service. We offer support in logo design, brand positioning, tone of voice and everything else needed to help you resonate with your audience.'),
        new ServicesItems('service2','Brand Management & Implementation','Good brand management is at the core of our focus. We embody your brand through immersing ourselves in everything you do, working closely with your team to drive both consistency and distinction in every application.'),
        new ServicesItems('service3','Signage & Environmental Graphics','We understand the importance and balance of well executed signage. Our team is adept at understanding the priorities of brand presence over budget and work with sites and suppliers to ensure each scheme is executed in detail and to the specific needs of each site.'),
        new ServicesItems('service4','Project Management','Our focus is not only on the perfect scheme but the perfect delivery of each project phase from start to finish. We collaborate with our suppliers to make sure all elements of each project are thoroughly assessed and managed with continuous feedback to all key stakeholders.'),
        new ServicesItems('service5','Exhibition Design','When it comes to exhibitions its important that your experience is both true to your brand but also unique. Our aim is to create unique experiences that help your brand resonate with your audience and rise above the competition, whilst considering the importance of re-use and sustainability at all times.Our experienced designers work with you and your team throughout the design, build, delivery and installation phases to ensure your event is a success.'),
        new ServicesItems('service6','Animation Design','Animated video content allows you to get your message across in a short space of time with high levels of customer engagement. We offer services from highly visual motion graphics to creating fully immersive 3D animated scenes.'),
        new ServicesItems('service7','Interior & Architectural Design','We design, manage and fuse both structural and interior design in one streamlined process in house. This continuity, and by combining our efforts and knowledge, allows us to deliver more cohesive, and holistic spatial solutions at a higher calibre.'),
        new ServicesItems('service8','Industrial Product Design','We dedicate our time to our clients to understand their vision, thoroughly define the brief or underpin the problem at its source, to deliver considered and well executed products by blending creative vision and technical know-how with our own twist.')
    ];

    const hoverGridSection = (column,row) => {
        const colObject = {
            1: '5fr 1fr 1fr',
            2: '1fr 5fr 1fr',
            3: '1fr 1fr 5fr'
        };
        const rowObject = {
            1: '5fr 1fr 1fr',
            2: '1fr 5fr 1fr',
            3: '1fr 1fr 5fr'
        };
        expandingGridRef.current.style.gridTemplateColumns = colObject[column];
        expandingGridRef.current.style.gridTemplateRows = rowObject[row];
    }

    const hoverGridReset = () => {
        expandingGridRef.current.style.gridTemplateColumns = '1fr 1fr 1fr';
        expandingGridRef.current.style.gridTemplateRows = '1fr 1fr 1fr';
    }

    //SVG stuff

    let fill = 'rgb(243,243,243)';
    let height = '160';

    let xVaryModifier = (height)/12.34675; //9.69;
    let yVaryModifier = (height)/5.61954; //21.29;

    let outerDiameter = (height)/2;
    let outerDiameterConst = (height)/2;
    let innerDiameter = (height)/3.32333;

    const outerRadius = outerDiameter / 2;
    const innerRadius = innerDiameter / 2;

    const pathSemi = `
      M ${-outerRadius},0
      A ${outerRadius},${outerRadius} 0 0,1 ${outerRadius},0
      L ${innerRadius},0
      A ${innerRadius},${innerRadius} 0 0,0 ${-innerRadius},0
      Z
    `;

    const animationDuration = '2s';
    const primaryKeyTimes = "0; 0.3; 0.4; 0.6; 0.7; 1"
    const rotationKeyTimes = "0; 0.3; 0.7; 1"

    const translationKeySplines = "0.1 0.8 0.2 1; 0.1 0.8 0.2 1; 0.1 0.8 0.2 1; 0.1 0.8 0.2 1; 0.1 0.8 0.2 1";
    const rotationKeySplines = "0 0 0.58 1; 0.1 0.8 0.2 1; 0.42 0 1 1";

    const singleRotateUpper = `-227.5; -47.5; -47.5; 132.5`;
    const doubleRotateUpper = `-407.5; -47.5; -47.5; 312.5`;

    const singleRotateLower = `-47.5; 132.5; 132.5; 312.5`;
    const doubleRotateLower = `-227.5; 132.5; 132.5; 492.5`;

    // ease ≈ 0.25 0.1 0.25 1

    // linear = 0 0 1 1

    // ease-in ≈ 0.42 0 1 1

    // ease-out ≈ 0 0 0.58 1

    // ease-in-out ≈ 0.42 0 0.58 1

    const useSplines = true;
    const doubleRotate = false;

    return (
        <main>
            <section ref={firstImageCon} id="fullScreenImage" className={styles.fullScreenImageContainer}>
                <div className={styles.carouselControls}>
                    <div className={styles.carouselButton} onClick={prevCarouselImg}></div>
                    <div className={styles.carouselButton} onClick={nextCarouselImg}></div>
                </div>
                <div ref={firstImage} className={styles.fullScreenImageInnerCon}>
                    <div ref={carousel} onTransitionEnd={handleCarouselTransitionEnd} className={styles.carouselCon} style={
                        {
                            width: `${extendedCarousel.length}00%`,
                            transform: `translateX(-${carouselImg * (100/extendedCarousel.length)}%)`,
                            transition: carouselTransitioning? '0.5s' : "none"
                        }
                    }>
                        {extendedCarousel.map((obj,i) => {
                            if(obj.type === "img"){
                                return (
                                    <div key={i} className={styles.carouselImg} style={{backgroundImage: `url(${obj.src})`}}></div>
                                )
                            } else {
                                return (
                                    <div className={styles.carouselVidCon}>
                                        <video key={i} onLoadedData={() => setVideoLoaded(true)} autoPlay muted loop playsInline style={{pointerEvents: "none"}}>
                                            <source src={obj.src} type="video/mp4"/>
                                        </video>
                                        <div className={styles.videoLoadingDiv} style={{opacity: `${videoLoaded? '0' : '1'}`}}>
                                            {/* <SLogoLoading fill={'#fff'}/> */}
                                            <iframe
                                            width={`${height}`}
                                            height={`${height}`}
                                            style={{border: 0}}
                                            src={`data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${height} ${height}'%3E%3Cdefs%3E%3ClinearGradient id='edgeFade'%3E%3Cstop offset='0%25' stop-color='${fill}' stop-opacity='0'%3E%3Canimate attributeName='stop-opacity' values='0;0;1;1;0;0' keyTimes='${primaryKeyTimes}' dur='${animationDuration}' repeatCount='indefinite'/%3E%3C/stop%3E%3Cstop offset='100%25' stop-color='${fill}' stop-opacity='1'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cg%3E%3Cg%3E%3CanimateTransform attributeName='transform' type='translate' values='${outerDiameterConst} ${outerDiameterConst}; ${outerDiameterConst} ${outerDiameterConst}; ${outerDiameterConst+(xVaryModifier/2)} ${outerDiameterConst-(yVaryModifier/2)}; ${outerDiameterConst+(xVaryModifier/2)} ${outerDiameterConst-(yVaryModifier/2)}; ${outerDiameterConst} ${outerDiameterConst}; ${outerDiameterConst} ${outerDiameterConst}' keyTimes='${primaryKeyTimes}' dur='${animationDuration}' keySplines='${useSplines? translationKeySplines : ''}' calcMode="splines" repeatCount='indefinite'/%3E%3Cg%3E%3CanimateTransform attributeName='transform' type='rotate' values='${doubleRotate? doubleRotateUpper : singleRotateUpper}' keyTimes='${rotationKeyTimes}' keySplines='${useSplines? rotationKeySplines : ''}' calcMode="splines" dur='${animationDuration}' repeatCount='indefinite'/%3E%3Cpath d='M -40 0 A 40 40 0 0 1 40 0 L 24 0 A 24 24 0 0 0 -24 0 Z' fill='url(%23edgeFade)'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3CanimateTransform attributeName='transform' type='translate' values='${outerDiameterConst} ${outerDiameterConst}; ${outerDiameterConst} ${outerDiameterConst}; ${outerDiameterConst-(xVaryModifier/2)} ${outerDiameterConst+(yVaryModifier/2)}; ${outerDiameterConst-(xVaryModifier/2)} ${outerDiameterConst+(yVaryModifier/2)}; ${outerDiameterConst} ${outerDiameterConst}; ${outerDiameterConst} ${outerDiameterConst}' keyTimes='${primaryKeyTimes}' calcMode="splines" dur='${animationDuration}' repeatCount='indefinite'/%3E%3Cg%3E%3CanimateTransform attributeName='transform' type='rotate' values='${doubleRotate? doubleRotateLower : singleRotateLower}' keyTimes='${rotationKeyTimes}' keySplines='${useSplines? rotationKeySplines : ''}' calcMode="splines" dur='${animationDuration}' repeatCount='indefinite'/%3E%3Cpath d='M -40 0 A 40 40 0 0 1 40 0 L 24 0 A 24 24 0 0 0 -24 0 Z' fill='url(%23edgeFade)'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E`}>
                                            </iframe>
                                        </div>
                                    </div>
                                )
                            }
                        } )}
                    </div>
                </div>
            </section>
            <section>
                <div className={styles.carouselProgressCon}>
                    {/* {carouselImg >= carouselImgs.length? carouselImgs.length : carouselImg <= 0? 1 : carouselImg} */}
                    {carouselImgs.map((thing,index) => <div className={`${styles.carouselSlideSelector} ${visibleCarouselImg === index+1? styles.selected : ''}`} onClick={() => handleClickSlideNo(index+1)}></div>)}
                </div>
            </section>
            {/* <section className={styles.introTextSection}>
                <div className={styles.introTextCon}>
                    <h2 ref={weBuildH2Ref}>We <span>Build</span>, <span>Manage</span><br/> & <span>Implement</span> Brands</h2>
                </div>
                <div className={styles.introTextCon}>
                    <h5 ref={weBuildH5Ref}>We deliver connected brand experiences across both physical and digital touchpoints.</h5><br/>
                    <h6 ref={weBuildH6Ref}>At Stratela, we provide strategic and innovative guidance that enhances both aesthetic value and functional performance. Our skills extend across product development and interior design to branding and graphic design, ensuring integrated, high‑impact solutions that transform ideas into results with precision and purpose.</h6>
                    
                </div>
            </section> */}
            <div className={styles.restrictedWidthWrapper}>
                {/* <div style={{ height: 'fit-content'}}>
                    <AnimatedMap mapWidth={'100%'}/>
                </div> */}
                <h2 className={styles.processHeading}>Our Process</h2>
                <section className={styles.processContainer} ref={processContainer}>
                    <div className={`${styles.processRowContainer} ${styles.headings}`}>
                        <div className={`${styles.headingsRow}`} ref={processHeadingsContainer}>
                            <div ref={process1Heading}>
                                <h4>01</h4>
                                <h3>Interact & <br/> Evaluate</h3>
                            </div>
                            <div ref={process2Heading}>
                                <h4>02</h4>
                                <h3>Design</h3>
                            </div>
                            <div ref={process3Heading}>
                                <h4>03</h4>
                                <h3>Develop</h3>
                            </div>
                            <div ref={process4Heading}>
                                <h4>04</h4>
                                <h3>Deliver</h3>
                            </div>
                            <div ref={process5Heading}>
                                <h4>05</h4>
                                <h3>Support</h3>
                            </div>
                        </div>
                    </div>
                    <div ref={processBarConOuterRef} className={`${styles.processProgressBarConOuter} ${styles.desktop}`}>
                        <div ref={processBarConRef} className={styles.processProgressBarCon}>
                            <div ref={processBarRef} className={styles.processProgressBarElement}></div>
                        </div>
                    </div>
                    <div className={`${styles.processRowContainer} ${styles.content}`}>
                        <div className={styles.desktopSpacer}></div>
                        <div className={styles.headingMobile}>
                            <h4>01</h4>
                            <h3>Interact & <br/> Evaluate</h3>
                        </div>
                        <div className={styles.processContentViewport}>
                            <div className={styles.processContentSlider} ref={processSlider1}>
                                <div className={styles.processContentImg}>
                                    <img src={'./imgs/nov2025Imgs/visionPurpose/colours_new_o.jpg'}/>
                                </div>
                                <div>
                                    <p ref={processSlider1Text}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut semper ex at sapien blandit rutrum. Fusce lorem sem, rhoncus sed turpis ut, lobortis viverra quam. Nulla facilisi. Aliquam erat volutpat. Mauris vel euismod eros, quis auctor dolor. Nullam a ante eget risus ornare semper at non tortor.<br/><br/>Nunc in nulla auctor, accumsan odio sed, dapibus eros. Vestibulum facilisis ultrices elit et feugiat. Mauris dictum metus ut erat gravida, eu dignissim urna efficitur. Suspendisse placerat luctus odio sollicitudin posuere. Nulla viverra a risus nec luctus. Aenean a mollis ligula. Nulla elementum nulla a ligula laoreet lobortis.</p>
                                </div>
                            </div>
                        </div>
                        <div className={styles.headingMobile}>
                            <h4>02</h4>
                            <h3>Design</h3>
                        </div>
                        <div className={styles.processContentViewport}>
                            <div className={styles.processContentSlider} ref={processSlider2}>
                                <div className={styles.processContentImg}>
                                    <img src={'./imgs/interiorDesVis/overviewRender1.jpg'}/>
                                </div>
                                <div>
                                    <p ref={processSlider2Text}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut semper ex at sapien blandit rutrum. Fusce lorem sem, rhoncus sed turpis ut, lobortis viverra quam. Nulla facilisi. Aliquam erat volutpat. Mauris vel euismod eros, quis auctor dolor. Nullam a ante eget risus ornare semper at non tortor.<br/><br/>Nunc in nulla auctor, accumsan odio sed, dapibus eros. Vestibulum facilisis ultrices elit et feugiat. Mauris dictum metus ut erat gravida, eu dignissim urna efficitur. Suspendisse placerat luctus odio sollicitudin posuere. Nulla viverra a risus nec luctus. Aenean a mollis ligula. Nulla elementum nulla a ligula laoreet lobortis.</p>
                                </div>
                            </div>
                        </div>
                        <div className={styles.headingMobile}>
                            <h4>03</h4>
                            <h3>Develop</h3>
                        </div>
                        <div className={styles.processContentViewport}>
                            <div className={styles.processContentSlider} ref={processSlider3}>
                                <div className={styles.processContentCollage}>
                                    <div className={styles.collage1b}>
                                        <div className={styles.collageImg} >
                                            <img src={'./imgs/redditch/waitingAfter.jpg'} className={styles.vertical}/>
                                        </div>
                                    </div>
                                    <div className={styles.collage2b}>
                                        <div className={styles.collageImg} >
                                            <img src={'./imgs/nov2025Imgs/designStrategy/mobile/kiosks_comp.jpg'}/>
                                        </div>
                                    </div>
                                    <div className={styles.collage3b}>
                                        <div className={styles.collageImg}>
                                            <img src={'./imgs/nov2025Imgs/designStrategy/web/kioskDismantled_comp.jpg'}/>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <p ref={processSlider3Text}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut semper ex at sapien blandit rutrum. Fusce lorem sem, rhoncus sed turpis ut, lobortis viverra quam. Nulla facilisi. Aliquam erat volutpat. Mauris vel euismod eros, quis auctor dolor. Nullam a ante eget risus ornare semper at non tortor.<br/><br/>Nunc in nulla auctor, accumsan odio sed, dapibus eros. Vestibulum facilisis ultrices elit et feugiat. Mauris dictum metus ut erat gravida, eu dignissim urna efficitur. Suspendisse placerat luctus odio sollicitudin posuere. Nulla viverra a risus nec luctus. Aenean a mollis ligula. Nulla elementum nulla a ligula laoreet lobortis.</p>
                                </div>
                            </div>
                        </div>
                        <div className={styles.headingMobile}>
                            <h4>04</h4>
                            <h3>Deliver</h3>
                        </div>
                        <div className={styles.processContentViewport}>
                            <div className={styles.processContentSlider} ref={processSlider4}>
                                <div className={styles.processContentCollage}>
                                    <div className={styles.collage1a}>
                                        <div className={styles.collageImg}>
                                            <img src={'./imgs/redditch/waitingAfter.jpg'} className={styles.vertical}/>
                                        </div>
                                    </div>
                                    <div className={styles.collage2a}>
                                        <div className={styles.collageImg}>
                                            <img src={'./imgs/nov2025Imgs/designStrategy/mobile/kiosks_comp.jpg'} className={styles.vertical}/>
                                        </div>
                                    </div>
                                    <div className={styles.collage3a}>
                                        <div className={styles.collageImg}>
                                        <img src={'./imgs/redditch/waitDeskTyreAftercomp.jpg'} className={styles.vertical}/>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <p ref={processSlider4Text}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut semper ex at sapien blandit rutrum. Fusce lorem sem, rhoncus sed turpis ut, lobortis viverra quam. Nulla facilisi. Aliquam erat volutpat. Mauris vel euismod eros, quis auctor dolor. Nullam a ante eget risus ornare semper at non tortor.<br/><br/>Nunc in nulla auctor, accumsan odio sed, dapibus eros. Vestibulum facilisis ultrices elit et feugiat. Mauris dictum metus ut erat gravida, eu dignissim urna efficitur. Suspendisse placerat luctus odio sollicitudin posuere. Nulla viverra a risus nec luctus. Aenean a mollis ligula. Nulla elementum nulla a ligula laoreet lobortis.</p>
                                </div>
                            </div>
                        </div>
                        <div className={styles.headingMobile}>
                            <h4>05</h4>
                            <h3>Support</h3>
                        </div>
                        <div className={styles.processContentViewport}>
                            <div className={styles.processContentSlider} ref={processSlider5}>
                                <div className={styles.processContentImg}>
                                    <img src={'./imgs/nov2025Imgs/designStrategy/web/OLD/IMG_2665.jpg'}/>
                                </div>
                                <div>
                                    <p ref={processSlider5Text}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut semper ex at sapien blandit rutrum. Fusce lorem sem, rhoncus sed turpis ut, lobortis viverra quam. Nulla facilisi. Aliquam erat volutpat. Mauris vel euismod eros, quis auctor dolor. Nullam a ante eget risus ornare semper at non tortor.<br/><br/>Nunc in nulla auctor, accumsan odio sed, dapibus eros. Vestibulum facilisis ultrices elit et feugiat. Mauris dictum metus ut erat gravida, eu dignissim urna efficitur. Suspendisse placerat luctus odio sollicitudin posuere. Nulla viverra a risus nec luctus. Aenean a mollis ligula. Nulla elementum nulla a ligula laoreet lobortis.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.processProgressBarConOuter} ${styles.mobile}`}>
                        <div ref={processBarConRefMobile} className={styles.processProgressBarCon}>
                            <div ref={processBarRefMobile} className={styles.processProgressBarElement}></div>
                        </div>
                    </div>
                </section>
            </div>
            <section ref={movingLogoCon} className={styles.oToSContainer}>
                <div ref={movingLogoBlock}>
                    {displayMovingLogo? 
                    <div style={{position: 'relative'}}>
                        <div style={{position: 'absolute'}}>
                            <SLogoNew scrollState={logoStatePt1} height={'100vh'} width={'100cqw'} viewportHeight={window.innerHeight} mask={true} logoScale={`${1-0.5*(logoStatePt2)}`} background={'1'} maskId="titleSLogo"/>
                        </div>
                        <div style={{maskImage: `linear-gradient(-47.5deg, black ${((2*logoStatePt2))*100}%, transparent 0%)`}}>
                            <SLogoNew scrollState={logoStatePt1} height={'100vh'} width={'100cqw'} viewportHeight={window.innerHeight} mask={false} logoScale={`${1-0.5*(logoStatePt2)}`} background={'1'} fill={'rgba(243, 243, 243,1)'}/>
                            {/* <div className={styles.fullImage} style={{backgroundImage: 'url(./imgs/semiCirclePattern.png'}}></div> */}
                        </div>
                    </div> : ''}
                </div>
            </section>
            <div className={styles.restrictedWidthWrapper}>
                <section id="ourWorkSection" ref={servicesCarouselRef} className={styles.servicesCarousel}>
                    <div ref={servicesCarouselInteriorConRef} className={`${styles.servicesInteriorCon}`}>
                    <div className={`${styles.servicesProgressBar} ${serviceActiveSlide === null? styles.near : styles.far}`} style={{opacity: `${serviceActiveSlide === null? '1' : '0'}`}}>
                        <div className={styles.servicesProgressBarElement} style={{height: `${serviceProgress*100}%`, display: `${serviceActiveSlide === null? 'block' : 'none'}`}}></div>
                    </div>
                    <div ref={servicesCarouselInteriorRef} className={`${styles.servicesInterior} ${styles.noSelect} ${serviceActiveSlide === null? '' : styles.activeSlide}`}>
                        <h2 className={`${styles.serviceHeading} ${styles.noSelect}`}>Our Work</h2>
                        {serviceBlockData.map((item,index) => (
                            <div className={`${styles.servicesBlockContainer} ${styles.noSelect}`}>
                                <div className={`${styles.servicesBlockContainerInner} ${styles.noSelect} ${serviceCurrentSlide === index? styles.currentSlide : styles.stdSlide} ${serviceActiveSlide === index? styles.activeSlide : ''}`}>
                                    <div ref={serviceBlocks.current[index]} key={index} className={`${styles.servicesBlock} ${serviceCurrentSlide === index? styles.currentSlide : styles.stdSlide} ${serviceActiveSlide === index? styles.activeSlide : ''}`} style={{left: `${serviceActiveSlide === index? '-'+((window.innerWidth-(servicesCarouselRef.current.getBoundingClientRect().right-servicesCarouselRef.current.getBoundingClientRect().left))/2)+'px' : 0}`}}>

                                        <div className={styles.openCurrentToActive} style={{zIndex: `${serviceActiveSlide !== null && serviceActiveSlide !== index? '0' : '12'}`}} onClick={() => expandServiceBlock(true,index)}></div>

                                        <div className={styles.slides}>
                                            <div className={styles.firstImgPane} style={{opacity: `${serviceCurrentSlide === index? 1 : 0}`}}>
                                                <div className={styles.fullImage} style={{backgroundImage: `url(${item.img})`}}>

                                                </div>
                                            </div>
                                            {item.slidesNew.map((slide,index2) => (
                                                <div className={styles.slideOpacityContainer} style={{opacity: `${serviceActiveSlide === index && serviceSlideShow >= (index2)? 1 : 0}`}}>{slide.slideContent(serviceActiveSlide === index && serviceSlideShow >= (index2))}</div>
                                            ))}
                                        </div>

                                        <div className={`${styles.slideshowOverlay} ${styles.noSelect}`}>
                                            <div className={`${styles.overlay} ${styles.noSelect}`}>
                                                <div className={`${styles.overlayFlexEle} ${styles.noSelect}`}>
                                                    {/* <div className={styles.overlayFlexEleHeading}> */}
                                                        <h4 className={`${styles.noSelect} ${styles.heading}`}>{item.name}</h4>
                                                        {/* <h4 className={`${styles.noSelect} ${styles.headingCopy}`}>{item.name}</h4> */}
                                                    {/* </div> */}
                                                    {serviceCurrentSlide === index? <button>View</button> : <h3 className={`${styles.noSelect}`}>+</h3>}
                                                    
                                                    {/* <button>Learn more</button> */}
                                                </div>
                                            </div>
                                            <div className={styles.slideshowInvisibleControlsCon}>
                                                <div className={styles.slideshowInvisibleControls}>
                                                    <div onClick={() => navigateBackwardSlideShow(false)}></div>
                                                    <div onClick={() => navigateForwardSlideShow(item.slidesNew.length - 1,false)}></div>
                                                </div>
                                            </div>
                                            <div className={styles.slideShowBottomControls}>
                                                <div>
                                                    <button type="button" className={styles.closeButton} onClick={closeSlideShow}>Close</button>
                                                </div>
                                                <div>
                                                    <button type="button" className={styles.leftButton} onClick={() => navigateBackwardSlideShow(true)} disabled={serviceCurrentSlide === 0 && serviceSlideShow === 0}>{serviceSlideShow === 0? 'Prev Section' : 'Prev'}</button>
                                                    <button type="button" className={styles.rightButton} onClick={() => navigateForwardSlideShow(item.slidesNew.length - 1,true)} disabled={serviceCurrentSlide === serviceBlockData.length-1 && serviceSlideShow === item.slidesNew.length - 1}>{serviceSlideShow === item.slidesNew.length - 1? 'Next Section' : 'Next'}</button>
                                                </div>
                                            </div>
                                            <div className={styles.slideShowProgressCon}>
                                                <div style={{width: `${((serviceSlideShow+1)*100)/(item.slidesNew.length)}%`}}  className={`${styles.slideShowBar} ${styles.full}`}></div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    </div>
                </section>
            </div>
            <section ref={secondImageCon} className={`${styles.fullScreenImageContainer} ${styles.thin}`}>
                <div ref={secondImage} className={`${styles.fullScreenImage}`}>
                </div>
            </section>
            <div className={styles.restrictedWidthWrapper}>
                <section ref={designStratConRef} className={styles.scrollImgTextSection}>
                    <div className={styles.largeTextContainer}>
                        <div ref={designStratTextRef} className={styles.smallTextContainer}>
                            <h2 ref={designStratH2Ref}>Design<br/>& Strategy</h2>
                            <br/>
                            <h5 ref={designStratH5Ref}>We challenge conventional thinking, apply rigorous problem‑solving, and design solutions that drive meaningful improvement.</h5><br/>
                            <h6 ref={designStratH6Ref}>Aligning design decisions to customer needs whilst also considering business aspirations, stakeholders and user needs, enables us to undertake more effective and efficient product development.</h6>
                       </div>
                    </div>
                    <div className={styles.imgsContainer}>
                        <img className={styles.p} src={`${'./imgs/nov2025Imgs/designStrategy/mobile/kiosks_comp.jpg'}`}/>
                        <img src={`${'./imgs/nov2025Imgs/designStrategy/web/sebPi_comp.jpg'}`}/>
                        <img src={`${'./imgs/nov2025Imgs/designStrategy/web/kioskDismantled_comp.jpg'}`}/>
                    </div>
                </section>
            </div>
            <div  id="aboutUsSection"  className={styles.restrictedWidthWrapper}>
                <section ref={aboutUsConRef} className={styles.scrollImgTextSection}>
                    <div className={styles.largeTextContainer}>
                        <div ref={aboutUsTextRef} className={styles.smallTextContainer}>
                            <h2 ref={aboutUsH2Ref}>About Us</h2>
                            <br/>
                            <h5 ref={aboutUsH5Ref}>Stratela is a passionate, detail orientated, multidisciplinary creative design agency.</h5><br/>
                            <h6 ref={aboutUsH6Ref}>Guided by curiosity and discipline, we join forces with clients to ignite ideas, challenge perceptions, and deliver lasting impact. Our work encompasses strategy and positioning, graphical identity, products and packaging, installations and events, websites and digital experiences, advertising and communications, 3D and data visualizations.</h6>
                        </div>
                    </div>
                    <div className={styles.imgsContainer}>
                        <img src={`${'./imgs/nov2025Imgs/aboutUs/sebDesk_comp.jpg'}`}/>
                        <img className={styles.p} src={`${'./imgs/nov2025Imgs/aboutUs/stairsPlant_comp.jpg'}`}/>
                        <img src={`${'./imgs/nov2025Imgs/aboutUs/guyWork_comp.jpg'}`}/>
                    </div>
                </section>
            </div>
            <section id="valuesSection" ref={valuesRef} className={styles.valuesSectionCon}>
                <div ref={valuesInteriorRef} className={styles.valuesSection}>
                    <div className={styles.valuesSectionHeadingCon}>
                        <h2 ref={valuesH2Ref}>Values & Principles</h2>
                    </div>
                    <div className={styles.spinners}>
                        <Spinners data={spinnersArray[0]} spin={spin1}/>
                        <Spinners data={spinnersArray[1]} spin={spin2}/>
                        <Spinners data={spinnersArray[2]} spin={spin3}/>
                        <Spinners data={spinnersArray[3]} spin={spin4}/>
                    </div>
                    <div className={styles.valuesSectionParaCon}>
                        <h6 ref={valuesH6Ref} className={styles.thin}>Client openness and transparency are values that we take into every project we work on.
                        At the heart of this is our belief in building strong relationships with our clients through surpassing expectations and effective communication.</h6>
                    </div>
                </div>
            </section>
            <section className={styles.videoSection}>
                <video id="s_intro" autoPlay muted loop playsInline style={{pointerEvents: "none"}}>
                    <source src={require('./../../vids/S-Intro.mp4')} type="video/mp4"/>
                </video>
                {/* <h1 id="titleText" style={{top: headingStyles.top, opacity: headingStyles.opacity}}>Design<br/>& Strategy<br/>Agency</h1> */}
            </section>
            <div className={styles.restrictedWidthWrapper}>
                <section ref={visionPurposeConRef} className={styles.scrollImgTextSection} style={{margin: '8rem 0'}}>
                    <div className={styles.largeTextContainer}>
                        <div ref={visionPurposeTextRef} className={styles.smallTextContainer}>
                            <h2 ref={visionPurposeH2Ref}>Vision<br/> & Purpose</h2>
                            <br/>
                            <h5 ref={visionPurposeH5Ref}>We design because we believe that progress and positive change can be achieved through better design.</h5><br/>
                            <h6 ref={visionPurposeH6Ref}>We seek innovation through a human centred approach to aesthetics and function. With every problem comes an array of solutions. We support our clients through identifying and enacting these solutions and share in their growth and progress.</h6>
                        </div>
                    </div>
                    <div className={styles.imgsContainer}>
                        <img className={styles.p} src={`${'./imgs/nov2025Imgs/visionPurpose/colours_new_o.jpg'}`}/>
                        <img src={`${'./imgs/nov2025Imgs/visionPurpose/meeting_room_new_o.jpg'}`}/>
                        <img src={`${'./imgs/nov2025Imgs/visionPurpose/browntable_new_o.jpg'}`}/>
                    </div>
                </section>
            </div>
        </main>
    )
}